import React from "react";
import { Avatar, Card, Col, Grid, Row, Space, theme, Typography } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./GamePicker.css";

type Game = { to: string; labelKey: string; icon: React.ReactNode };

type GamePickerProps = {
    games: Game[];
    titleKey: string;
    icon: React.ReactNode;
    maxWidth: number;
    columns: { sm: number; md?: number; lg?: number };
    bordered?: boolean;
    playerCountKey?: string;
};

const GamePicker: React.FC<GamePickerProps> = ({ games, titleKey, icon, maxWidth, columns, bordered, playerCountKey }) => {
    const { token } = theme.useToken();
    const screens = Grid.useBreakpoint();
    const { t } = useTranslation();

    return (
        <div className="sf-game-picker" style={{ maxWidth }}>
            <Space direction="vertical" size="large" style={{ width: "100%", textAlign: "center" }}>
                <Avatar size={screens.xs ? 48 : 64} icon={icon} style={{ backgroundColor: token.colorPrimary, margin: "0 auto" }} />
                <Typography.Title level={1} style={{ margin: 0 }}>{t(titleKey)}</Typography.Title>
                <Row gutter={[screens.xs ? 12 : 24, 24]} justify="center" align="middle">
                    {games.map((game) => {
                        const descriptionKey = `games.details.${game.labelKey.split(".").pop()}.description`;
                        const detailDescription = t(descriptionKey);
                        const homeDescriptionKey = `pages.drinkhelper.gameDescriptions.${game.labelKey.split(".").pop()}`;
                        const homeDescription = t(homeDescriptionKey);
                        return (
                        <Col xs={24} {...columns} key={game.labelKey}>
                            <Link to={game.to} className="sf-game-picker-link">
                                <Card hoverable variant={bordered === false ? "borderless" : "outlined"} style={{
                                    borderRadius: 12,
                                    boxShadow: token.boxShadowSecondary,
                                    minHeight: 130,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }} styles={{ body: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    padding: screens.xs ? "18px 0" : "26px 0",
                                } }}>
                                    <Avatar size={screens.xs ? 40 : 48} style={{ backgroundColor: token.colorInfo, marginBottom: 14 }} icon={game.icon} />
                                    <Typography.Text style={{ fontSize: screens.xs ? 16 : 18, fontWeight: 500, color: token.colorTextHeading }}>
                                        {t(game.labelKey)}
                                    </Typography.Text>
                                    {(detailDescription !== descriptionKey || homeDescription !== homeDescriptionKey) && <Typography.Paragraph className="sf-game-picker-description">{detailDescription !== descriptionKey ? detailDescription : homeDescription}</Typography.Paragraph>}
                                    {playerCountKey && <Typography.Text className="sf-game-picker-count">{t(playerCountKey)}</Typography.Text>}
                                </Card>
                            </Link>
                        </Col>
                        );
                    })}
                </Row>
            </Space>
        </div>
    );
};

export default GamePicker;
